import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {adminT, adminWithSpeculatorT} from '@/lib/types/admin.types';

interface ADMIN_STATE {
  admins: adminT[] | [];
  adminsWithSpeculators: adminWithSpeculatorT[] | [];
  isLoading?: boolean;
  error?: string | null;
}

const ADMIN_INITIAL: ADMIN_STATE = {
  admins: [],
  adminsWithSpeculators: [],
  isLoading: false,
  error: null,
};

const adminSlice = createSlice({
  name: 'admin',
  initialState: {
    ...ADMIN_INITIAL,
  },
  reducers: {
    ADMIN_UPDATE: (state, action: PayloadAction<{data?: ADMIN_STATE; prop?: string; value?: string | Date}>) => {
      return (state = {
        ...state,
        ...(action.payload.data ? action.payload.data : null),
        ...(action.payload.prop ? {[action.payload.prop]: action.payload.value} : null),
      });
    },
  },
});

const {ADMIN_UPDATE} = adminSlice.actions;

export {adminSlice, ADMIN_INITIAL, ADMIN_UPDATE};
